import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ManagerService } from 'src/app/services/manager.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NavComponent } from 'src/app/traits/nav/nav.component';
import { ExportExcelService } from 'src/app/services/export-excel.service';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-moto-insurance',
  templateUrl: './moto-insurance.component.html',
  styleUrls: ['./moto-insurance.component.css']
})
export class MotoInsuranceComponent implements OnInit {

  insurance: any[] = []; add: boolean; filteredIns: any[] = []; response: any; search: string = '';
  private _searhcTitle: string;

  get searchTitle(): string {
    return this._searhcTitle;
  }
  set searchTitle(value: string) {
    this._searhcTitle = value;
    this.search = value;
    this.getMore(1,10);
    // this.filteredCust = this.searchResult(value);
  }
  constructor(
    private api: ApiService, 
    private _use: NavComponent, 
    private _api: ManagerService, 
    private _exp: ExportExcelService
  ) { }

  ngOnInit() {
    this.getAllInsurance();
  }

  getAllInsurance() {
    this.api.get('insurance?limit=8').subscribe((data: any) => {
      this.insurance = data.data; this.filteredIns = data.data; this.response = data;
    }, (err: HttpErrorResponse) => {
      this._use.showMsg('error', 'Insurance List Fail', 'Unable to Fetch Insurance List'); });
  }
  
  getMore(page,limit) {
    this.api.get('insurance?search='+this.search+'&page='+page+'&limit='+limit).subscribe((data: any) => {
      this.insurance = data; this.response = data; console.log(data);
      this.filteredIns = data.data;
    }, (err: HttpErrorResponse) => {
      this._use.showMsg('error', 'Insurance List Fail', 'Unable to Fetch Insurance List');
    });
  }

  Export() {
    this.Sort().then((data)=>{
      // return data;
      this._exp.exportAsExcelFile(data, 'customer');
    });
  }

  async Sort() {
    const insure = [];
    await this.filteredIns.forEach((c)=>{
      const ins = { code: c.code, name: c.fullname, mobile: c.mobile, email: c.email, address: c.address,
        dateofbirth: c.dateofbirth, digital_address: c.digital_address, postal_address: c.postal_address,
        package_id: c.package_id, status: c.status, cust_type: c.cust_type, cover: c.cover, cover_type: c.cover_type,
        vehicle: c.vehicle, vehicle_value: c.vehicle_value, worth: c.worth, model: c.model, color: c.color,
        no_of_seats: c.no_of_seats, year_of_manufacture: c.year_of_manufacture, chasis_number: c.chasis_number, reg_number: c.reg_number,
        body_type: c.body_type, type: c.type,  gender: c.gender,  
        locations: c.location.code, maritalstatus: c.maritalstatus, creationTime: c.date };
        insure.push(ins);
    });
    return insure;
  }

  searchResult(searchString: string) {
    // tslint:disable-next-line:max-line-length
    return this.insurance.filter(a => a.fullname.toLowerCase().indexOf(searchString.toLocaleLowerCase()) !== -1 || a.code.toLowerCase().indexOf(searchString.toLocaleLowerCase()) !== -1 || a.type.toLowerCase().indexOf(searchString.toLocaleLowerCase()) !== -1 || a.mobile.indexOf(searchString) !== -1);
  }


}





